import React from "react";
import { Snippet } from "react-instantsearch";

const translations = {
  en: {
    postType: {
      post: "News",
      page: "Page",
      resource: "Resource",
      "Page - Our Work": "Page - Our Work",
    },
  },
  fr: {
    postType: {
      post: "Nouvelles",
      page: "Page",
      resource: "Ressource",
      "Page - Our Work": "Page - Notre travail",
    },
  },
};

export default function Hit({ hit }) {
  const lang = document.documentElement.lang || "en";
  const t = translations[lang] || translations.en;

  const metadata = hit.metadata;
  const image = metadata?.featured_image;
  const imageSrc = image?.sizes?.large;
  const imgThumbSrc = image?.sizes?.medium;
  const focalPoint = metadata?.focal_point;
  const snippet = metadata?.snippet;
  const displayDate = metadata?.display_date;
  const categories = metadata?.categories;
  const author = metadata?.author;
  const publicationYear = metadata?.publication_year;
  const postTemplate = metadata?.post_template;
  // if postTemplate == page-our-work.php, then set postTemplate to "Our Work"

  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  const escapedTitle = htmlDecode(hit.post_title);

  let postTypeKey = hit.post_type;
  if (postTypeKey === "post") {
    postTypeKey = "post";
  }
  if (postTypeKey === "page" && postTemplate === "page-our-work.php") {
    postTypeKey = "Page - Our Work";
  }
  if (postTypeKey === "resource") {
    postTypeKey = "resource";
  }
  let postType = t.postType[postTypeKey] || postTypeKey;

  if (categories && Array.isArray(categories) && categories.length > 0) {
    const categoryNames = categories.map((cat) => cat.name).join(", ");
    postType += ` | ${categoryNames}`;
  }

  return (
    <article className="search-hit">
      <div className="search-hit-text">
        {imgThumbSrc && (
          <div className="search-hit-thumbnail">
            <img
              src={imgThumbSrc}
              alt={image.alt ? image.alt : ""}
              style={{ objectPosition: "50%" + focalPoint + "%" }}
              className="search-hit-thumbnail-image"
            />
          </div>
        )}
        <span className="all-caps">{postType}</span>
        <h2 className="h5">
          <a className="search-hit-tab-link" href={hit.permalink}>
            <span>{escapedTitle}</span>
          </a>
        </h2>
        <div className="search-hit-metadata">
          {displayDate && <span className="search-hit-date">{displayDate}</span>}
          {author && (
            <span className="search-hit-author">
              {author}
              {publicationYear && ` | ${publicationYear}`}
            </span>
          )}
        </div>
        {snippet ? (
          <Snippet attribute="metadata.snippet" hit={hit} className="search-hit-snippet" />
        ) : (
          <Snippet attribute="content" hit={hit} className="search-hit-snippet" />
        )}
      </div>
      <div className="search-hit-image">
        {imageSrc && (
          <img
            loading="lazy"
            alt={image.alt}
            style={{ objectPosition: "50%" + focalPoint + "%" }}
            src={imageSrc}
          />
        )}
      </div>
    </article>
  );
}
